<!-- Bar search / Header Text Container -->
<ng-container>
    <div class="flex flex-col w-full px-4 lg:px-6 py-1 justify-center min-h-[64px]">
        <!-- Título Principal -->
        <span class="text-gray-800 font-black text-lg lg:text-xl dark:text-white tracking-widest leading-tight">
            {{ getTitulo() }}
        </span>

        <!-- Subtítulo Dinámico -->
        <span *ngIf="_headerTextService.getSubtitulo()"
            class="hidden sm:block text-xs font-bold text-gray-400 tracking-widest mt-0.5 leading-tight">
            {{ _headerTextService.getSubtitulo() }}
        </span>
    </div>
</ng-container>